{
  "FormEngineHttpRequestDatasource": {
    "title": "HTTP-Anfrage",
    "description": "HTTP Request, dessen Ergebnis verwendet wird (erwartet CSV, YAML oder JSON)"
  },
  "mask": {
    "FormEngineHttpRequestDatasource": {
      "description": "Beschreibung",
      "url": "URL",
      "method": "Methode",
      "authGroupTitle": "Genehmigung",
      "responseGroupTitle": "Antwort",
      "sourceType": "Quelle Typ",
      "resultPath": "Ergebnispfad",
      "resultPathPlaceholder": "z.B. Einträge",
      "labelColumn": "Spalte beschriften",
      "labelColumnPlaceholder": "z.B. {{.Etikett}}",
      "valueColumn": "Wertspalte",
      "valueColumnPlaceholder": "z.B. {{.Wert}}",
      "setup": "Aufstellen",
      "data": "Durchsuche"
    }
  }
}